

























import Vue from 'vue'

import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class ShowDenuncias extends Vue {
  @Prop({ default: false, type: Boolean })
  private loading = false

  private dialog = false

  activar() {
    this.$emit('activar')
  }
  closeDialog() {
    this.dialog = false
  }

  openDialog() {
    this.dialog = true
  }
}
